import _ from 'lodash'

export const BTN_TYPE = {
  URL: 'url',
  PAYLOAD: 'payload',
  EVENT: 'event'
}

export const BTN_TYPES = _.values(BTN_TYPE)

export const FULLSCEEN_WIDTH_BREAKPOINT = 800


// WEBPACK FOOTER //
// ./src/constants.js